var PageTransition = {

	init: function(){
		
		//console.log("PAGE TRANSITION INIT");

		$(window).bind('beforeunload', function(){
			//console.log('_debug_ : hide body');
			$(".page-transition").removeClass("animated").addClass("hidden").delay("40").removeClass("hidden").addClass("animated visible");
		});

		$(window).on('load', function(){
			//console.log('_debug_ : hide body');
			Debug.log("INIT -> ")
			$(".page-transition").addClass("animated hidden").removeClass("visible");
		});
		
		setTimeout(function(){
			$(".page-transition").addClass("animated hidden").removeClass("visible");
		}, 1000);
	},
}

$(document).ready(function(){
	Debug.log("DOCUMENT READY");
	PageTransition.init();

});
$(window).bind("pageshow", function(event) {
	Debug.log("PAGE SHOW");
	$(".page-transition").addClass("animated hidden").removeClass("visible");
});
/*
if(navigator.userAgent.toLowerCase().indexOf('safari/') > -1){

};

if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
	$(".page-transition").addClass("animated hidden").removeClass("visible");
}
 */